(function () {
	'use strict';

	angular.module('qbePortal').controller('YearMakeModelSearchController', YearMakeModelSearchController);

	YearMakeModelSearchController.$inject = [
    '$rootScope',
		'$scope', 
		'regoSearchService', 
		'serviceResponseRepository', 
		'quoteModelFactory', 
		'labelService', 
		'storage'
	];

	function YearMakeModelSearchController(
    $rootScope,
		$scope, 
		regoSearchService, 
		serviceResponseRepository, 
		quoteModelFactory, 
		labelService, 
		storage) {
		var vm = this,
			searchType;

		vm.yearInput = null;
		vm.makeInput = '';
		vm.modelInput = '';
		vm.yearMakeModelResult = '';
		vm.modelResponse = null;
		vm.makeResponse = null;

		vm.bodyStyles = [];
		vm.engineSizes = [],
			vm.selectedBodyStyle = '';

		vm.resetSearchLabel = labelService.getLabelFor('resetSearch');

		vm.isMakeSearchInProgress= false ;
		vm.isModelSearchInProgress= false ;

		vm.yearMakeModelResults = '';

		var quoteModel = quoteModelFactory.create();
		vm.chosenResult = quoteModel.regoDetails ? quoteModel.regoDetails : null ;

		$scope.$on("recall-get-details", recallGetDetails);

		function recallGetDetails() {
			if (vm.modelInput){
				vm.getDetails(vm.modelInput);
			}
 		}

		function existsInArray(array, searchTerm, property) {
			for (var i = 0, len = array.length; i < len; i++) {
				if (array[i][property] === searchTerm) {
					return true;
				}
			}
			return false;
		}

		function getPastYears() {
			var years = [];
			var prevYear = '';

			for (var i = 0; i < 100; i++) {
				prevYear = moment().subtract(i, 'year').format('Y');
				years.push({label: prevYear, value: prevYear});
			}

			return years;
		}

		function buildArray(data, array, property) {

			if (data.length >= 5) {
				data.forEach(function (object) {
					var item = object[property];

					if (!existsInArray(array, item, 'value')) {
						array.push({
							value: item,
							label: item
						});
					}
				});
			}
		}

		var yearsObject = getPastYears();

		vm.searchBy = function (type) {
			return searchType == type;
		}

		vm.showSearch = function (type) {
			vm.chosenResult = null ;
			searchType = type;
		}

		vm.getYears = function () {
			return yearsObject;
		}

		vm.getPolicyStartDate = function() {
			return storage.getItem('policy-start-date');
		}

		// On change of Year dropdown, trigger a search for the Make.
		vm.searchMake = function (yearInput) {
			vm.yearInput = yearInput;

			var tempYear = null;

			if (tempYear !== vm.yearInput.value) {
				vm.makeInput = undefined;
				vm.modelInput = undefined;
				vm.yearMakeModelResults = '';
			}

			if (vm.yearInput.value !== '') {
				vm.isMakeSearchInProgress = true;
				vm.makeResponse = null;
				vm.modelResponse = null;
				tempYear = vm.yearInput.value;

				regoSearchService.searchMake({
					year: vm.yearInput.value,
					effectiveDate: vm.getPolicyStartDate(),
				}
				,function (resp) {
					vm.isMakeSearchInProgress = false
					vm.makeResponse = resp;
				});
			}
		}

		// On change of the Make dropdown, trigger a search for Model
		vm.searchModel = function (makeInput) {
			vm.makeInput = makeInput;

			var tempMake = null;

			if (tempMake !== vm.makeInput.value) {
				vm.modelInput = undefined;
				vm.yearMakeModelResults = '';
			}

			if (vm.makeInput !== '') {
				vm.isModelSearchInProgress = true;
				vm.modelResponse = null;

				regoSearchService.searchModel({
					year: vm.yearInput.value,
					make: vm.makeInput.code,
					effectiveDate: vm.getPolicyStartDate(),
				},function (resp) {
					vm.isModelSearchInProgress = false;
					vm.modelResponse = resp;
				});
			}
		}

		// Update the current car options based on engine/body filters
		vm.filterOptions = function (type) {

			if (type == 'bodyStyle') {
				vm.engineSizes = [];
				vm.selectedEngineSize = undefined;
			}

			// If only the body style is selected
			if (vm.selectedBodyStyle !== undefined && vm.selectedEngineSize == undefined) {
				vm.filteredOptions = vm.yearMakeModelResults.filter(filterArrayByBody);
			}

			// If only the engine size is selected
			if (vm.selectedEngineSize !== undefined && vm.selectedBodyStyle == undefined) {
				vm.filteredOptions = vm.yearMakeModelResults.filter(filterArrayByEngine);
			}

			// If both are selected
			if (vm.selectedEngineSize !== undefined && vm.selectedBodyStyle !== undefined) {
				vm.filteredOptions = vm.yearMakeModelResults.filter(filterArrayByBodyAndEngine);
			}

			// Rebuild the engine size array


			buildArray(vm.filteredOptions, vm.engineSizes, 'engineSize');

		}

		// On change of the Model dropdown, trigger a final search for the car details
		vm.getDetails = function (modelInput) {
			vm.yearMakeModelResults = '';
			vm.bodyStyles = [];
			vm.engineSizes = [];
			vm.selectedBodyStyle = undefined;
			vm.selectedEngineSize = undefined;

			vm.modelInput = modelInput;

			if (vm.modelInput !== undefined) {
				regoSearchService.searchCar({
					year: vm.yearInput.value,
					make: vm.makeInput.code,
					model: vm.modelInput.code,
					effectiveDate: vm.getPolicyStartDate(),
				}, function (resp) {
					buildArray(resp, vm.bodyStyles, 'bodyStyle');
					buildArray(resp, vm.engineSizes, 'engineSize');
					vm.yearMakeModelResults = resp;
					vm.filteredOptions = resp;
				});
			} else {
				vm.yearMakeModelResults = '';
				vm.chosenResult = '';
			}

		}

		function filterArrayByBodyAndEngine(item) {
			return item.bodyStyle == vm.selectedBodyStyle.value && item.engineSize == vm.selectedEngineSize.value ? 1 : 0;
		}

		function filterArrayByBody(item) {
			return item.bodyStyle == vm.selectedBodyStyle.value ? 1 : 0;
		}

		function filterArrayByEngine(item) {
			return item.engineSize == vm.selectedEngineSize.value ? 1 : 0;
		}

		function updateRepository() {
			vm.update({name: 'regoDetails', value: vm.chosenResult});
			serviceResponseRepository.update('regoSearch', vm.chosenResult);
		}

		vm.selectOption = function () {
			vm.chosenResult = vm.yearMakeModelResults[vm.yearMakeModelOption];
			updateRepository();

			$rootScope.$broadcast("bike-selected");
		}

		vm.isResultSelected = function () {
			return !!vm.chosenResult; // !== undefined && vm.chosenResult !== '';
		}

		vm.resetSearch = function () {
			vm.yearMakeModelOption = '';
			vm.chosenResult = null;
			vm.update({name: 'regoDetails', value: null});
			serviceResponseRepository.update('regoSearch', null);
		}

		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({name: name, setHierarchyFn: setHierarchyFn});
		}

	}

	angular.module('qbePortal').component('yearMakeModelSearch', {
		templateUrl: '/ngviews/components/qbYearMakeModelSearch.html',
		controller: YearMakeModelSearchController,
		controllerAs: 'vm',
		bindings: {
			update: '&',
			setHierarchy: '&',
			validationSelector: '@',
			hideSubFilters: '<',
			labelWildcard: '<',
		}
	});
})();
